import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

const ACTION_CLS = {
  create: "bg-emerald-50 text-emerald-700", update: "bg-blue-50 text-blue-700", delete: "bg-rose-50 text-rose-700",
  login: "bg-slate-100 text-slate-600", import: "bg-purple-50 text-purple-700", confirm: "bg-indigo-50 text-indigo-700",
  analyze: "bg-amber-50 text-amber-700", queue: "bg-sky-50 text-sky-700", bulk: "bg-slate-100 text-slate-700",
  connect: "bg-emerald-50 text-emerald-700", ai: "bg-fuchsia-50 text-fuchsia-700",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit?limit=300").then(({ data }) => setLogs(data)); }, []);

  return (
    <div>
      <PageHeader overline="Compliance" title="Audit-Log" subtitle="Wer hat was geändert, importiert, geplant oder veröffentlicht – vollständig nachvollziehbar." />
      <Card className="rounded-md border-slate-200 shadow-none overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs text-slate-500 sticky top-0">
            <tr><th className="px-4 py-2 font-semibold">Zeit</th><th className="px-4 py-2 font-semibold">Nutzer</th><th className="px-4 py-2 font-semibold">Aktion</th><th className="px-4 py-2 font-semibold">Objekt</th><th className="px-4 py-2 font-semibold">Details</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {logs.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`} className="hover:bg-slate-50">
                <td className="px-4 py-2 text-xs font-mono text-slate-400 whitespace-nowrap">{new Date(l.timestamp).toLocaleString("de-DE")}</td>
                <td className="px-4 py-2 font-medium">{l.user_name}</td>
                <td className="px-4 py-2"><span className={`text-[11px] font-semibold px-2 py-0.5 rounded-sm ${ACTION_CLS[l.action] || "bg-slate-100 text-slate-600"}`}>{l.action}</span></td>
                <td className="px-4 py-2 text-xs text-slate-500">{l.entity}</td>
                <td className="px-4 py-2 text-slate-600">{l.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
